import React from 'react';  
import './index.css';
 
import NoContent from 'component/noContent';
class InfoIntro extends React.Component{
  render(){
    const {info} = this.props
    return (
      <div className="tab-intro">
        <div className="intro-title">
          <p>{info&&info.get('brief')?info.get('brief'):null}</p>
        </div>
        <div className="intro-main">

          {
            info&&info.get('content')
            ?
            <p dangerouslySetInnerHTML={{__html: info.get('content')}}></p>
            :
            <NoContent/>
          }
        </div>
      </div>
      )
  }
}
 

 
 
export default InfoIntro;
 